var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 15C1 8.40033 1 5.1005 3.05026 3.05026C5.1005 1 8.40033 1 15 1C21.5996 1 24.8995 1 26.9497 3.05026C29 5.1005 29 8.40033 29 15C29 21.5996 29 24.8995 26.9497 26.9497C24.8995 29 21.5996 29 15 29C8.40033 29 5.1005 29 3.05026 26.9497C1 24.8995 1 21.5996 1 15Z",
    stroke: "#A9A7A7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.60059 20.3203L8.20059 22.0003L12.2006 17.8003",
    stroke: "#A9A7A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.60059 10.52L8.20059 12.2L12.2006 8",
    stroke: "#A9A7A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.3994 10.8003H23.3994",
    stroke: "#A9A7A7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.3994 20.6001H23.3994",
    stroke: "#A9A7A7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIcon);
export default __webpack_public_path__ + "static/media/GeneralIcon.570b5c6f1b03283311938f5bf4165c17.svg";
export { ForwardRef as ReactComponent };